import { BalanceRepayDialog } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {
    // return get.getMarketTypeList({sportType: Number(params.sportType)});
  },
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Use Wallet Balance');
      },
      class: 'h-[700px] bg-layer3-card',
    },
  },
};

export default BalanceRepayDialog;
